import SaleReports from './SaleReports';
import VoucherRedeemtionReports from './VoucherRedeemtionReports';

export default {
    SaleReports,
    VoucherRedeemtionReports,
}